import { render, staticRenderFns } from "./Product_SubForm.vue?vue&type=template&id=0957f90a&"
import script from "./Product_SubForm.vue?vue&type=script&lang=js&"
export * from "./Product_SubForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports